import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-settings-left-nav',
  templateUrl: './left-nav.component.html',
})
export class LeftNavComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
